import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

export type WindowState = 'open' | 'closed' | 'neveropened';

@Injectable()
export class BotatoWidgetManagerService {

    private userNotificationSubject: Subject<string> = new Subject();
    private openChatSubject: Subject<void> = new Subject();

    private chatWindowSubject: Subject<WindowState | undefined> = new BehaviorSubject<WindowState | undefined>(undefined);
    public chatWindowState$: Observable<WindowState | undefined> = this.chatWindowSubject.asObservable();

    public chatOpened$: Observable<void> = this.openChatSubject.asObservable();
    public userNotification$: Observable<string> = this.userNotificationSubject.asObservable();

    public notifyUser(message: string): void {
        this.userNotificationSubject.next(message);
    }

    public openChat(): void {
        this.openChatSubject.next();
    }

    public updateState(newWindowState: WindowState): void {
        this.chatWindowSubject.next(newWindowState);
    }
}
